import useI18n from "@I18n/hooks/useI18n";

export const useMoney = () => {
  const { formatNumber } = useI18n();

  const money = ({ cents, currency }: { cents: number; currency: string }) => {
    return formatNumber(cents / 100, {
      style: "currency",
      minimumFractionDigits: 0,
      currency,
    });
  };

  return {
    money,
  };
};
